import {loadStripe} from "./load_stripe";

up.compiler('#credit_card_form', function(form) {
  var $form = $(form)
  var $spinner = $form.find('#credit-card-spinner');

  function stripeResponseHandler(status, response) {
    if (response.error) {
      var $baseError = findOrCreateBaseError($form);
      $baseError.text(response.error.message);
      enableSubmitButton();
    } else {
      var token = response.id;
      $form.append($('<input type="hidden" name="plan_premium[stripe_token]">').val(token));
      up.submit($form)
    }
  }

  function findOrCreateBaseError($form){
    var $baseError = $form.find('.alert.alert-danger');
    if ($baseError.length === 0){
      $baseError = $('<div class="alert alert-danger" role="alert"/>');
      $form.prepend($baseError);
    }
    return $baseError;
  }

  function enableSubmitButton(){
    $form.find('.submit').prop('disabled', false);
    $spinner.hide()
  }

  function disableSubmitButton() {
    $form.find('.submit').prop('disabled', true);
    $spinner.show()
  }

  disableSubmitButton()

  loadStripe().then(function() {
    enableSubmitButton();
    $form.submit(function(event) {
      disableSubmitButton();
      Stripe.card.createToken($form, stripeResponseHandler);
      return false;
    });

  })
})
